import { useEffect, useRef, type FC } from 'react'

import type { timelineData } from 'data/timeline'

import { Entry, TextLimit } from './styled'

type Props = {
  readonly entry: (typeof timelineData)[number] & {
    index: number
    isActive: boolean
  }
  readonly observer?: IntersectionObserver
  readonly onMount: (element: Element | null) => void
  readonly onClick: (element: Element | null) => void
}

export const TimelineEntry: FC<Props> = ({
  entry,
  observer,
  onMount,
  onClick,
}) => {
  const ref = useRef<HTMLLIElement>(null)

  useEffect(() => {
    if (observer && ref.current) {
      observer.observe(ref.current)
    }
  }, [observer])

  useEffect(() => {
    onMount(ref.current)
  }, [])

  return (
    <Entry
      ref={ref}
      data-index={entry.index}
      data-is-even={entry.index % 2 === 0}
      $isActive={entry.isActive}
      onClick={() => onClick(ref.current)}
      tabIndex={entry.isActive ? -1 : 0}
    >
      <TextLimit>{entry.label}</TextLimit>
    </Entry>
  )
}
